import { isGameKey } from './profiles';
import { progressStore } from './progressStore';

/** Kept by "Start over": the grown-up settings (the player's age). */
const KEEP = new Set(['foe-names.settings.v1']);

/**
 * Starts the game over from scratch: stars, letters, the intro and story beats are forgotten, and
 * the page reloads at the start, so no screen keeps state in memory (QA 2026-10-11: "Start over"
 * only cleared the stars). Only the active profile's game state is cleared (game/profiles.ts); the
 * age, other profiles, debug and QA data stay.
 */
export function resetGame(): void {
  progressStore.reset();
  try {
    for (const key of Object.keys(localStorage)) {
      if (isGameKey(key) && !KEEP.has(key)) localStorage.removeItem(key);
    }
  } catch {
    // Storage blocked: only the in-memory progress was reset.
  }
  // Replaced without a hashchange, so nothing renders before the reload.
  window.history.replaceState(null, '', '#/');
  window.location.reload();
}
